import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import TeamOperationsSectionEditMixin from "./TeamOperationsSectionEditMixin";
import TeamOperationsFieldInput from "./TeamOperationsFieldInput.vue";
import TeamOperationsEditFooter from "./TeamOperationsEditFooter.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
/**
 * Add / Edit Process: Sub-item and Value / Frequency per process item.
 */
let TeamOperationsProcessModal = /** @class */ (() => {
    let TeamOperationsProcessModal = class TeamOperationsProcessModal extends Mixins(TeamOperationsSectionEditMixin) {
    };
    TeamOperationsProcessModal = __decorate([
        Component({
            name: "TeamOperationsProcessModal",
            components: {
                SectionLoader,
                TeamOperationsFieldInput,
                TeamOperationsEditFooter,
            },
        })
    ], TeamOperationsProcessModal);
    return TeamOperationsProcessModal;
})();
export default TeamOperationsProcessModal;
